/*-----------------------------------------------------------------
- Cart configs
-----------------------------------------------------------------*/
export default {
    
    repayment_model_key: 'repayment',
    
};
